﻿import { payment_transaction } from "./payment_transaction";

export class payment {
    public sellingCompany: string | null = null;
    public agencyId: string | null = null;
    public transactionInfo: payment_transaction = new payment_transaction();
}